import axios from "axios";

export default async function getList({ id, email, role, banned, validTrader }) {
    try {
        const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/admin/list`,
            {
                withCredentials: true,
                validateStatus: () => true,
                params: {
                    ...(id !== undefined && id !== null ? { id } : {}),
                    ...(email ? { email } : {}),
                    ...(role ? { role } : {}),
                    ...(banned !== undefined ? { ban: banned } : {}),
                    ...(validTrader !== undefined ? { trader: validTrader } : {}),
                },
            }
        );

        return {
            ok: res.status >= 200 && res.status < 300,
            status: res.status,
            data: res.data,
        };
    } catch (err) {
        return { ok: false, status: 0, error: err.message };
    }
}
